import { inject, Injectable } from '@angular/core';
import { UnsupportedBrowserPopup } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { UnsupportedBrowserAdapterService } from '../../adapters/unsupported-browser/unsupported-browser-adapter.service';
import { HeaderFooterMachCoreContentService } from '../../services/header-footer-mach-core/header-footer-mach-core-content.service';
import { CookieHelperService } from '../../services/utils/cookie-helper/cookie-helper.utils.service';

@Injectable({
  providedIn: 'root'
})
export class UnsupportedBrowserFacadeService {
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  adapter = inject(UnsupportedBrowserAdapterService);
  cookieHelper = inject(CookieHelperService);
  unsupportedBrowserPopup$ = new BehaviorSubject<UnsupportedBrowserPopup>(
    {} as UnsupportedBrowserPopup
  );

  init(): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .pipe(take(1))
      .subscribe((content) => {
        this.unsupportedBrowserPopup$.next(
          this.adapter.transformContent(content)
        );
      });
  }

  getBadBrowser(cookieName: string) {
    const browserCookie = this.cookieHelper.getCookieValue(cookieName);
    if (browserCookie != null && browserCookie.length > 0) {
      return browserCookie;
    }
    return '';
  }

  setBadBrowser(cookieName: string, expiryDays: number): void {
    this.cookieHelper.setCookieName(
      cookieName,
      true,
      expiryDays,
      false,
      '/',
      '.delta.com'
    );
  }
}
